import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { Observable } from 'rxjs';
import { User } from '@angular/fire/auth';

/**
 * Shared admin shell: brand bar + account menu, wrapping the merchant
 * administration screens (list/add/edit merchant).
 *
 * There is currently only one admin section (merchants), so no nav links
 * are shown — a menu with a single item that just points back to the page
 * you're already on adds chrome without adding navigation. If a second
 * admin section is added later, this is the place to reintroduce a nav.
 *
 * Presentation-only: it reads the already-signed-in user via the existing
 * AuthService.getCurrentUser()/logout() methods and does not add any new
 * authentication behavior.
 */
@Component({
  selector: 'app-admin-shell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-shell.component.html',
  styleUrl: './admin-shell.component.scss',
})
export class AdminShellComponent {
  currentUser$: Observable<User | null>;

  constructor(private authService: AuthService) {
    this.currentUser$ = this.authService.getCurrentUser();
  }

  signOut(): void {
    this.authService.logout().subscribe();
  }

  initialsFor(email: string | null | undefined): string {
    if (!email) {
      return 'A';
    }
    return email.charAt(0).toUpperCase();
  }
}
